import { ScaleDetails } from '../shared/ontology/model/scale-details';
import { MethodDetails } from '../shared/ontology/model/method-details';
import { PropertyDetails } from '../shared/ontology/model/property-details';
import { VariableDetails } from '../shared/ontology/model/variable-details';
import { Injectable } from '@angular/core';

@Injectable()
export class OntologyContext {
    scaleDetails: ScaleDetails;
    methodDetails: MethodDetails;
    propertyDetails: PropertyDetails;
    variableDetails: VariableDetails;
    previousVariableRoute: number[];
}
